export const tablePagination = {
  defaultPageSize: 10,
  showSizeChanger: true,
  pageSizeOptions: ["10", "20", "40", "80", "100"],
};
export const tableScroll ={
    x: `100%`, y: `calc(calc(var(--vh, 1vh) * 100) - 150px)` 
}